import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '@core/providers/http';
import { BolseiroService } from '../../api/services/bolseiro.service';
import { CardPersonBolseirosComponent } from '@app/shared/components/card-person-bolseiros/card-person-bolseiros.component';
import { Bolseiro } from '../../api/models';

@Component({
  selector: 'app-listar-bolseiros',
  standalone: true,
  templateUrl: './listar-bolseiros.component.html',
  styleUrls: ['./listar-bolseiros.component.scss'],
  providers: [BolseiroService, ApiService],
  imports: [CommonModule, CardPersonBolseirosComponent],
})
export class ListarBolseirosComponent implements OnInit {
  @Input() bolsaID!: string;
  bolseiros: Bolseiro[] = [];
  bolseiroService = inject(BolseiroService);
  totalRecords: number = 0;
  page: number = 1;
  rows: number = 10;
  ngOnInit(): void {
    this.loadBolseirosByBolsaID();
  }

  loadBolseirosByBolsaID(queryParams?: any) {
    this.bolseiroService.list({ ...queryParams, page: this.page, rows: this.rows }).subscribe(
      (response: { data: Bolseiro[], totalRecords: number }) => {
        this.bolseiros = response.data;
        this.totalRecords = response.totalRecords;
      },
      (error: any) => {
        console.error('Erro ao buscar bolseiros:', error);
      }
    );
  }
}
